jQuery(function($){
	$('#form_rfq_services_serviceneeded_other').parent().hide()
	$('#form_rfq_services_serviceneeded').on('change', function(){
		if($(this).val() == 'Other'){
			$('#form_rfq_services_serviceneeded_other').parent().show()
		}
		else{
			$('#form_rfq_services_serviceneeded_other').parent().hide()
		}
	})

	$('#label_referrer_other').parent().hide()
	$('select[name*="referrer"]').on('change', function(){
		if($(this).val() == 'Other'){
			$('#label_referrer_other').parent().show()
		}
		else{
			$('#label_referrer_other').parent().hide()
		}
	})
})
